module.exports = __webpack_public_path__ + "img/bold-reader.d5f41378.png";